const BREADCRUMB_KEY = "theme-breadcrumbs";

const saveBreadcrumb = () => {
  const oldData = JSON.parse(window.sessionStorage.getItem(BREADCRUMB_KEY) || "{}");

  try {
    const pageData = {
      current: JSON.parse(document.querySelector("[data-page-data]").innerHTML),
      previous: oldData.current,
    };

    window.sessionStorage.setItem(BREADCRUMB_KEY, JSON.stringify(pageData));
  } catch (error) {
    console.warn("unable to save breadcrumb", error);
  }
};

saveBreadcrumb();

window.getBreadcrumbData = () => {
  try {
    const pageData = window.sessionStorage.getItem(BREADCRUMB_KEY);
    return JSON.parse(pageData);
  } catch (error) {
    console.warn("unable to read breadcrumb data", error);
    return null;
  }
};

class DynamicBreadcrumb extends HTMLElement {
  constructor() {
    super();

    try {
      const pageData = window.sessionStorage.getItem(BREADCRUMB_KEY);
      if (pageData) {
        const { previous } = JSON.parse(pageData);
        if (!previous) return;

        const { path, page_type, collection_title } = previous;
        if (page_type !== this.type) return;

        const a = this.querySelector("a");
        a.href = path;

        if (a.innerHTML.trim() === "") {
          a.innerHTML = collection_title;
        }

        const section = this.closest("[data-breadcrumb-section]");

        if (section) {
          section.querySelectorAll(this.hide).forEach((el) => (el.style.display = "none"));
        }

        this.breadcrumbParent.style.display = null;
      }
    } catch (error) {
      this.breadcrumbParent.style.display = "none";
      console.warn("unable to read breadcrumb data", error);
    }
  }

  get breadcrumbParent() {
    return this.closest("[data-breadcrumb-parent]");
  }

  get type() {
    return this.getAttribute("type");
  }

  get hide() {
    return this.getAttribute("hide");
  }
}

if (!customElements.get("dynamic-breadcrumb")) {
  customElements.define("dynamic-breadcrumb", DynamicBreadcrumb);
}
